import Button from "@joinTrilo/ui/atoms/Button";
import {
    StyledBody,
    StyledButtonWrapper,
    StyledHeader,
    StyledWordingWrapper,
} from "./Auth.styled";
import { StyledCamelLog } from "../Pay/Pay.styled";

export const GuestCheckout = ({
    userWantsToLogin,
    submitAnon,
}: {
    userWantsToLogin: (wants: boolean) => void;
    submitAnon: () => Promise<void>;
}) => {
    return (
        <StyledCamelLog>
            <StyledWordingWrapper>
                <StyledHeader>Pay in seconds and get rewarded</StyledHeader>
                <StyledBody>
                    Sign in or create your account to make the most of your
                    payment experience 🚀
                </StyledBody>
            </StyledWordingWrapper>
            <StyledButtonWrapper>
                <Button
                    size="md"
                    text="Sign in"
                    isDisabled={false}
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        userWantsToLogin(true);
                    }}
                    type="submit"
                />

                <Button
                    size="md"
                    text="Guest checkout"
                    isDisabled={false}
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        submitAnon();
                    }}
                    type="submit"
                    isPastel={true}
                    isLoading={false}
                />
            </StyledButtonWrapper>
        </StyledCamelLog>
    );
};
